import { Badge, Box, Card, CardBody, Divider, Heading, HStack, Link, Text, VStack } from '@chakra-ui/react'
import type { DashboardHealthItem } from './types'

type DashboardHealthSectionProps = {
  title: string
  statusLabel: string
  statusColor: string
  items: DashboardHealthItem[]
  cardBg: string
  textColor: string
  subtitleColor: string
  borderColor: string
  viewMonitoringLabel: string
  onOpenMonitoring: () => void
}

export function DashboardHealthSection(props: DashboardHealthSectionProps) {
  const {
    title,
    statusLabel,
    statusColor,
    items,
    cardBg,
    textColor,
    subtitleColor,
    borderColor,
    viewMonitoringLabel,
    onOpenMonitoring,
  } = props

  return (
    <Card bg={cardBg} borderRadius="xl" boxShadow="sm">
      <CardBody p={{ base: 4, md: 6 }}>
        <HStack justify="space-between" align="center" mb={4}>
          <Heading size={{ base: 'sm', md: 'md' }} color={textColor}>
            {title}
          </Heading>
          <Badge colorScheme={statusColor} cursor="pointer" onClick={onOpenMonitoring}>
            {statusLabel}
          </Badge>
        </HStack>
        <VStack align="stretch" spacing={3}>
          {items.map((item, index) => (
            <Box key={item.label}>
              <HStack justify="space-between" minW={0}>
                <Text fontSize="sm" color={subtitleColor} minW={0} overflowWrap="anywhere">
                  {item.label}
                </Text>
                <Text fontSize="sm" fontWeight="semibold" color={textColor} flexShrink={0}>
                  {item.value}
                </Text>
              </HStack>
              {index !== items.length - 1 && (
                <Divider mt={3} borderColor={borderColor} />
              )}
            </Box>
          ))}
        </VStack>
        <Link
          mt={4}
          display="inline-block"
          fontSize="sm"
          color="blue.500"
          onClick={onOpenMonitoring}
        >
          {viewMonitoringLabel}
        </Link>
      </CardBody>
    </Card>
  )
}
